
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import AnalysisServices from './components/AnalysisServices';
import ChemicalSupply from './components/ChemicalSupply';
import FieldChallenges from './components/FieldChallenges';
import CustomSolutions from './components/CustomSolutions';

const Services = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <ServicesHero />
      <AnalysisServices />
      <ChemicalSupply />
      <FieldChallenges />
      <CustomSolutions />
      <Footer />
    </div>
  );
};

export default Services;
